import { globalEndpoints } from './global';

export const patientEndpoints = {
  getPatient: (patientIdEncrypted, refreshApplication) => `${globalEndpoints.apiUrl}/Patient/${patientIdEncrypted}/${refreshApplication}`,
  getOrders: (patientIdEncrypted, options) => {
    const queryString = Object.keys(options)
      .map((eachOption) => `${eachOption}=${options[eachOption]}`)
      .join('&');

    return `${globalEndpoints.apiUrl}/Patient/${patientIdEncrypted}/Orders?${queryString}`;
  },
  getOrderCards: (patientIdEncrypted) => {
    return `${globalEndpoints.apiUrl}/Patient/${patientIdEncrypted}/OrderRouteInformation`;
  },
  removePhysician: (patientIdEncrypted) => {
    return `${globalEndpoints.apiUrl}/Patient/${patientIdEncrypted}/LeavePhysician`;
  },
  updatePatientPhoneEmail: () => `${globalEndpoints.apiUrl}/Application/UpdatePatientPhoneEmail`,
  getPhysicianCertifications: (patientIdEncrypted, options) => {
    const queryString = Object.keys(options)
      .map((eachOption) => `${eachOption}=${options[eachOption]}`)
      .join('&');

    return `${globalEndpoints.apiUrl}/Certification/${patientIdEncrypted}/certifications?${queryString}`;
  },
  getCertificationInformation: (certificationIdEncrypted) => {
    return `${globalEndpoints.apiUrl}/Certification/${certificationIdEncrypted}/certificationInformation`;
  },
  createNewCertification: () => `${globalEndpoints.apiUrl}/Certification/NewCertification`,
  createRfe: () => `${globalEndpoints.apiUrl}/CertificationDocumentation/AddRfe`
};
